import { createFileRoute } from "@tanstack/react-router"

import { DesktopSettings } from "@/crm/components/settings/desktop/settings"
import { MobileSettings } from "@/crm/components/settings/mobile/settings"
import { Adaptive } from "@/crm/lib/viewport"

export const Route = createFileRoute("/_crm/settings")({
  component: SettingsRoute,
})

function SettingsRoute() {
  return <Adaptive desktop={<DesktopSettings />} mobile={<MobileSettings />} />
}
